import React, { useEffect } from 'react';
import MainLayout from '../components/layout/MainLayout';
import Section from '../components/ui/Section';
import Button from '../components/ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Assessment = () => {
  const claritySessionLink = "https://tidycal.com/1x8odpm/ai-clarity-session-1y6rlrd-mpnrkpl";

  useEffect(() => {
    // Dynamically load the Quizify embed script
    const script = document.createElement('script');
    script.src = "https://app.quizify.io/js/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <MainLayout>
      <Section bg="white" className="pt-10 md:pt-20 pb-4 md:pb-8">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h1 className="text-3xl md:text-5xl font-extrabold text-brand-navy mb-6 tracking-tight">
            AI Leadership Health Check
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Find out how prepared your social impact organisation is to implement AI with confidence and integrity.
          </p>
        </div>
      </Section>

      <Section bg="cream" className="pt-2 md:pt-4 pb-16">
        <div className="max-w-5xl mx-auto px-2 sm:px-4">
          <div className="bg-white rounded-xl md:rounded-3xl shadow-xl overflow-hidden border border-gray-100 p-4 md:p-8">
            {/* Quizify Embed Container */}
            <div className="min-h-[600px] flex flex-col items-center justify-center">
              <quizify 
                className="quizifyio_embed w-full" 
                data-quizid="5f7f02b7e4ade23430f345f954c938c1"
              ></quizify>
            </div>
          </div>

          <div className="mt-8 text-center px-4">
            <div className="flex flex-col items-center gap-2">
              <p className="text-gray-500 text-xs md:text-sm">
                Having trouble with the health check?
              </p>
              <Button to="/contact" variant="ghost" className="text-brand-teal font-semibold py-2">
                Contact Support <SafeIcon icon={FiIcons.FiArrowRight} className="ml-2" />
              </Button>
            </div>
          </div>
        </div>
      </Section>

      <Section bg="navy">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Need a walkthrough instead?
          </h2>
          <p className="text-gray-300 mb-8 text-lg">
            If you'd prefer to discuss your AI leadership strategy with a human, book a Clarity Session with Tomar.
          </p>
          <Button href={claritySessionLink} variant="primary" className="bg-brand-gold text-brand-navy hover:bg-yellow-500 font-bold">
            Book a Clarity Session
          </Button>
        </div>
      </Section>
    </MainLayout>
  );
};

export default Assessment;